import logo from '@/assets/image/logo/logo_512.png';

import styles from './index.module.less';

const Auth403 = () => (
  <div className={styles.wrapper403}>
    <div className={styles.content}>
      <img width="150px" src={logo} />
      <h1>暂无权限</h1>
    </div>
  </div>
);

export default Auth403;
